import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { noop } from 'rev-shared/util';

import { IVideoReviewReplyEntry } from './VideoReviewTypes';

import styles from './VideoReview.module.less';

@Component({
	selector: 'video-review-reply-entry',
	host: { '[class]': 'styles.replyEntryRoot' },
	template: `
		<div [ngClass]="styles.entry">
			<div [ngClass]="styles.entryIconWrapper">
				<vb-profile-picture
					[altTxt]="'UserProfile_ProfilePicture' | translate"
					[profileUrl]="reply.user.profileImageUri"
					[size]="'large'">
				</vb-profile-picture>
			</div>
			<div [ngClass]="styles.entryDetails">
				<div [ngClass]="styles.entryHeading">
					<span [ngClass]="styles.manualEntryHeadingName">{{ reply.user.fullName || reply.user.userName }}</span>
					&nbsp;-&nbsp;{{ reply.when | vbDateTimeMedium }}
				</div>
				<div [ngClass]="styles.entryContent">
					<span [innerHTML]="reply.reply"></span>
				</div>
				<div *ngIf="isDeleteVisible && !isReadOnlyMode" [ngClass]="styles.entryFooter">
					<button type="button" class="btn btn-transparent" [ngClass]="styles.entryBtn" (click)="onDeleteReplyClick()">
						{{ 'Delete' | translate }}
					</button>
				</div>
			</div>
		</div>
	`
})
export class VideoReviewReplyEntryComponent implements OnInit {
	@Input({ required: true }) public reply: IVideoReviewReplyEntry;
	@Input({ required: true }) public currentUserId: string;
	@Input({ required: true }) public isReadOnlyMode: boolean;
	@Output() public deleteClicked = new EventEmitter<string>();

	public readonly styles = styles;

	public isDeleteVisible: boolean;

	constructor(
		private DialogService: DialogService,
		private TranslateService: TranslateService
	) { }

	public ngOnInit(): void {
		this.isDeleteVisible = this.reply.user.id === this.currentUserId;
	}

	public onDeleteReplyClick(): void {
		this.DialogService.openConfirmationDialog({
			title: this.TranslateService.instant('DeleteReply'),
			message: this.TranslateService.instant('DeleteReply_Confirm'),
			actionText: this.TranslateService.instant('Yes'),
			cancelText: this.TranslateService.instant('No'),
			themed: true
		}).result
			.then(() => {
				this.deleteClicked.emit(this.reply.replyId);
			})
			.catch(noop);
	}

}
